import projectImportsConstants from './constants'
import projectImportsService from './services'

const fetchAll = (projectId, page = null) => {
  const request = () => ({
    type: projectImportsConstants.FETCH_ALL_REQUEST
  })
  const success = (projectImports) => ({
    projectImports,
    type: projectImportsConstants.FETCH_ALL_SUCCESS
  })
  const failure = (error) => ({
    error,
    type: projectImportsConstants.FETCH_ALL_FAILURE
  })

  return (dispatch) => {
    dispatch(request())

    projectImportsService.fetchAll(projectId, page)
      .then((projectImports) => dispatch(success(projectImports)))
      .catch((error) => dispatch(failure(error)))
  }
}

export default {
  fetchAll
}
